import { useCountdown } from "@/utils/useCountdown"

interface CountdownDisplayProps {
    dataFim: string | null
    showDaysIfPositive?: boolean
}

export function Counter({ dataFim, showDaysIfPositive = true }: Readonly<CountdownDisplayProps>) {
    const { dias, horas, minutos, segundos } = useCountdown(dataFim)
    
    if (!dataFim) return null

    return (
        <div className="alinha-contador">
            {showDaysIfPositive && dias !== "00" && (
                <span className="ctn dia">
                    <span className="count">{dias}d</span>
                    <span className="text">:</span>
                </span>
            )}
            <span className="ctn hora">
                <span className="count">{horas}h</span>
                <span className="text">:</span>
            </span>
            <span className="ctn min">
                <span className="count">{minutos}m</span>
                <span className="text">:</span>
            </span>
            <span className="ctn seg">
                <span className="count">{segundos}s</span>
            </span>
        </div>
    )
}
